import {
  DiMaDetailsContent,
  DiMaDetailsContentProps,
} from "../../../../components/DiMaDetailsContent"
import { FeedbackGet } from "../../../../models/Feedback"
import { getNiceFormattedDate } from "../../../../utils/getFormattedDate"

export function FeedbackDetails(props: { readonly feedback: FeedbackGet }) {
  const { feedback } = props

  const detailsContentProps: DiMaDetailsContentProps = {
    inlineEdit: false,
    listItems: [
      {
        id: 0,
        label: "Application",
        displayItem: <div className="title">{feedback.application.name}</div>,
      },
      {
        id: 1,
        label: "Topic",
        displayItem: <div className="title">{feedback.topic.name}</div>,
      },
      {
        id: 2,
        label: "Description",
        displayItem: (
          <div
            className="title"
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              width: "100%",
              display: "block",
            }}
          >
            {feedback.description}
          </div>
        ),
      },
      {
        id: 3,
        label: "Creation date",
        displayItem: (
          <div className="title">{getNiceFormattedDate(feedback.creationDate)}</div>
        ),
      },
      {
        id: 4,
        label: "Version",
        displayItem: <div className="title">{feedback.version}</div>,
      },
      {
        id: 5,
        label: "Operating System",
        displayItem: <div className="title">{feedback.operatingSystem}</div>,
      },
      {
        id: 6,
        label: "Completed By",
        displayItem: <div className="title">{feedback.completedBy?.username}</div>,
      },
      {
        id: 7,
        label: "Completion Date",
        displayItem: (
          <div className="title">
            {feedback.completionDate
              ? getNiceFormattedDate(feedback.completionDate)
              : ""}
          </div>
        ),
      },
    ],
  }

  return <DiMaDetailsContent {...detailsContentProps} />
}
